

export default {
  highlights: [{
      title: "Remap any key or combination",
    description: "Now your function keys can actually be useful."
    }, {
      title: "Switch between different profiles",
      description: "Your keyboard should be dynamic, just like you."
    }, {
      title: "Use across all of your computers",
      description: "Share your hotkeys across all of your favorite computers."
    }, {
      title: "Cross Platform",
      description: "Use a Mac, PC, or both? We got you covered."
  }],
    betaCallout: {
      title: 'Be the first to get access',
      subTitle: 'Leave your email to sign up for the beta program.',
      ps: [
        'Major key will always be free to download.',
        'Beta program members will have full access to all of the apps features while it is in development.',
        '(must be willing to receive occasional emails to get feedback from you)'
      ]
    }
}



// WEBPACK FOOTER //
// ./src/data/data.js